import React from 'react';
import styled from 'styled-components';
import { getPageMessage } from '../../shared/constants/pageMessages';

const ExhibitionVenueViewer: React.FC = () => {
  return (
    <ViewerShell>
      <ScrollBody>
        <ComingSoon>{getPageMessage('EXHIBITION_DETAIL_COMING_SOON')}</ComingSoon>
      </ScrollBody>
    </ViewerShell>
  );
};

const ViewerShell = styled.section`
  position: relative;
  flex: 1;
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: flex-start;
`;

const ComingSoon = styled.div`
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_04};
`;

export default ExhibitionVenueViewer;
